import { ReactNode, useId } from 'react';
import { Box, Typography } from '@mui/material';

export function SelectionField({
  label,
  children,
  feedback,
}: {
  label: string;
  children: ReactNode;
  feedback?: ReactNode;
}) {
  const labelId = useId();
  return (
    <Box sx={{ display: 'grid', gap: 1 }}>
      <Typography id={labelId} variant="body1" sx={{ fontWeight: 500 }}>
        {label}
      </Typography>
      <Box
        role="group"
        aria-labelledby={labelId}
        sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}
      >
        {children}
      </Box>
      {feedback}
    </Box>
  );
}
